exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header[data-v-81b10cb2] {\n  justify-content: space-between;\n  margin-bottom: 20px;\n  height: 60px;\n  margin: 0 80px 20px 16px;\n}\n.header-bar[data-v-81b10cb2] {\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n}\n.header-bar h1[data-v-81b10cb2] {\n    margin: 0;\n    padding: 0;\n    padding: 16px 0;\n}\n", ""]);

// exports
